import { LOCALES } from 'utils';
import { slugMaker } from 'utils/normalizer';

const IUMS_TABS = {
  [LOCALES.FA]: ['دروس رشته', 'برنامه درسی', 'پایان‌نامه‌ها'].map(item => ({name: item, slug: slugMaker(item)})),
  [LOCALES.EN]: ['Courses', 'Time Table', 'Thesis'].map(item => ({name: item, slug: slugMaker(item)}))
};

export const generateIumsMetaTags = (groupName: string, tabName: string) => {
  const MAPPED_DESCRIPTION = {
    [IUMS_TABS[LOCALES.FA][0].slug]:`در این صفحه تمامی دروس رشته ${groupName} و دروس گرایش‌های مختلف این رشته به همراه تعداد واحد هر درس و تخصصی و اختیاری بودن آن را مشاهده خواهید کرد.`,
    [IUMS_TABS[LOCALES.FA][1].slug]:`در این صفحه برنامه درسی رشته ${groupName} و گرایش‌های آن را در مقاطع تحصیلی مختلف در دانشگاه خاتم مشاهده خواهید کرد که شامل ساعت هر کلاس، استاد، مکان و زمان کلاس و امتحان است.`,
    [IUMS_TABS[LOCALES.FA][2].slug]:`در این صفحه موضوعات پایان‌ نامه‌های کارشناسی ارشد ${groupName} به همراه نام دانشجو، گرایش تحصیلی، استاد راهنمای مربوطه و تاریخ دفاع هر کدام را مشاهده خواهید کرد.`,
  }
  return {
    title: `${tabName?.replaceAll('-', ' ') || ''}`,
    get description() {
      for(let key in MAPPED_DESCRIPTION) {
        if(tabName.includes(key))
          return MAPPED_DESCRIPTION[key]
      }
      for(let key in MAPPED_DESCRIPTION) {
        return MAPPED_DESCRIPTION[key]
      }
    }
  }
}

const translation = {
  [LOCALES.FA]: {
    DEFAULT_TITLE: 'جزییات گروه آموزشی',
    NOT_FOUND: 'موردی یافت نشد!',
    BREADCRUMB: [{ title: 'صفحه اصلی', link: '/' }],
    IUMS_TABS: IUMS_TABS[LOCALES.FA],
    MAPPED_IUMS_TABS: {
      COURSES: IUMS_TABS[LOCALES.FA][0],
      TIME_TABLE: IUMS_TABS[LOCALES.FA][1],
      THESIS: IUMS_TABS[LOCALES.FA][2]
    },
    AND: 'و'
  },
  [LOCALES.EN]: {
    DEFAULT_TITLE: 'Group Details',
    NOT_FOUND: 'Not Found!',
    BREADCRUMB: [{ title: 'Home', link: '/' }],
    IUMS_TABS: IUMS_TABS[LOCALES.EN],
    MAPPED_IUMS_TABS: {
      COURSES: IUMS_TABS[LOCALES.EN][0],
      TIME_TABLE: IUMS_TABS[LOCALES.EN][1],
      THESIS: IUMS_TABS[LOCALES.EN][2]
    },
    AND: 'and'
  }
};

export default translation;
